module.exports = __webpack_public_path__ + "static/img/loading.ae373e2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.gif
// module id = F7NO
// module chunks = 3